// Iter 108v — DeleteTicketDialog extracted from Helpdesk.jsx.
// Soft-delete only — restore path lives in Settings → Helpdesk →
// Deleted Tickets (365-day retention).

import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

export function DeleteTicketDialog({ ticket, onClose, onDeleted }) {
  const [busy, setBusy] = useState(false);
  const confirm = async () => {
    setBusy(true);
    try {
      await api.delete(`/helpdesk/tickets/${ticket.ticket_id}`);
      toast.success(`Ticket ${ticket.cf_id} moved to trash`);
      onDeleted?.();
    } catch { toast.error("Delete failed"); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="helpdesk-delete-dialog">
        <DialogHeader>
          <DialogTitle>Delete ticket {ticket.cf_id}?</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 text-sm text-slate-600">
          <p><span className="font-medium text-slate-800">{ticket.subject}</span></p>
          <div className="rounded-md border border-amber-200 bg-amber-50 p-3 text-xs text-amber-800">
            <p className="mb-1 font-semibold">This is a soft-delete.</p>
            <ul className="list-disc pl-4 space-y-0.5">
              <li>The ticket is hidden from the board immediately.</li>
              <li>It stays restorable under
                <span className="font-mono">&nbsp;Settings → Helpdesk → Deleted Tickets</span>&nbsp;
                for <b>365 days</b>.</li>
              <li>After 365 days it is <b>permanently purged</b> automatically.</li>
            </ul>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={busy}>Cancel</Button>
          <Button variant="destructive" onClick={confirm} disabled={busy}
                  data-testid="helpdesk-delete-confirm"
                  className="bg-rose-600 text-white hover:bg-rose-700">
            {busy ? "Deleting…" : "Move to Trash"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
